import { BrowserRouter as Router } from "react-router-dom"

import { createRoot } from "react-dom/client"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
// core styles
import "./scss/volt.scss"

// vendor styles
import "@fortawesome/fontawesome-free/css/all.css"
import "react-datetime/css/react-datetime.css"
import "leaflet/dist/leaflet.css"

import "semantic-ui-css/semantic.min.css"
//App Styles
import "./css/app.css"
import i18next from "i18next"
import App from "./App"

import "@hookstate/devtools"
import { resources } from "./common/languages"
import { I18nextProvider } from "react-i18next"
import { ToastProvider } from "./components/Common/Toast"
import { ConfirmProvider } from "./components/Common/ConfirmDialog"
import ErrorBoundary from "./components/Common/ErrorBoundary"

const normalizeLanguage = value => {
  if (!value) return null
  const parts = value.split(/[-_]/)
  if (parts.length === 1) return parts[0].toLowerCase()
  return `${parts[0].toLowerCase()}_${parts[1].toUpperCase()}`
}

const storedLanguage = normalizeLanguage(localStorage.getItem("language"))

i18next.init({
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  lng: storedLanguage || "es_DO",
  fallbackLng: "es_DO",
  ns: ["global"],
  defaultNS: "global",
  resources: resources,
  debug: false,
})

const container = document.getElementById("root")
const root = createRoot(container)
root.render(
  <ErrorBoundary>
    <ToastProvider>
      <ConfirmProvider>
        <Router>
          <I18nextProvider i18n={i18next}>
            <App />
          </I18nextProvider>
        </Router>
      </ConfirmProvider>
    </ToastProvider>
  </ErrorBoundary>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.unregister()
